<div class="modal-body">
    <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
    <cm-signature></cm-signature>
    <div class="errors-container" [ngClass]="{ 'show-errors': !!error }">{{ error }}</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="backToPreviousPage()">BACK</button>
    <button type="button" class="btn btn-primary" (click)="submit()">SUBMIT</button>
</div>
